
/**
 * Copyright (c) 2018 Microsoft Corporation
 * Modules Registration
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

/**
 * Register all available modules
 */
export const registerAllModules = (requiredModules) => {
    let binding = { modules: {}, dataActions: {} };
    const { log, error }  = console;
    const detailedWebpackError = (msg, errorObject) => { error(msg); error(errorObject); process.env.NODE_ENV !== 'development' && error('Run in dev mode to see full list of errors'); process.exit(50); }
    const handleError = (modPath, errObject) => {
        detailedWebpackError('Error with path: ' + modPath, errObject);
    }
    if (requiredModules) {
        requiredModules = requiredModules.map((module) => module.toLowerCase());
    }
    const isNotRegistered = (moduleName) => {
        return !requiredModules || requiredModules.length <= 0 || requiredModules.findIndex((module) => module === moduleName) !== -1;
    };

    
    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    
    try {


    isNotRegistered('about-us') && (binding.modules['about-us'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-about-us' */
            'partner/modules/about-us/about-us.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'about-us',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/about-us'
    });
        

    isNotRegistered('about-us-2') && (binding.modules['about-us-2'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-about-us-2' */
            'partner/modules/about-us-2/about-us-2.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'about-us-2',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/about-us-2'
    });
        

    isNotRegistered('baby-doll-sleeping-bag') && (binding.modules['baby-doll-sleeping-bag'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-baby-doll-sleeping-bag' */
            'partner/modules/baby-doll-sleeping-bag/baby-doll-sleeping-bag.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'baby-doll-sleeping-bag',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/baby-doll-sleeping-bag'
    });
        

    isNotRegistered('be-amaized-by-this-popcorn-holder') && (binding.modules['be-amaized-by-this-popcorn-holder'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-be-amaized-by-this-popcorn-holder' */
            'partner/modules/be-amaized-by-this-popcorn-holder/be-amaized-by-this-popcorn-holder.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'be-amaized-by-this-popcorn-holder',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/be-amaized-by-this-popcorn-holder'
    });
        

    isNotRegistered('bike-safety-hand-signals') && (binding.modules['bike-safety-hand-signals'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-bike-safety-hand-signals' */
            'partner/modules/bike-safety-hand-signals/bike-safety-hand-signals.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'bike-safety-hand-signals',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/bike-safety-hand-signals'
    });
        

    isNotRegistered('chat-support') && (binding.modules['chat-support'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-chat-support' */
            'partner/modules/chat-support/chat-support.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'chat-support',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/chat-support'
    });
        

    isNotRegistered('checkout') && (binding.modules['checkout'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout' */
            'partner/modules/checkout/checkout.tsx'),
        $type: 'containerModule',
        da: [{name:'catalogs',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 1},{name:'products',  path:'modules/checkout/actions/get-products-in-active-checkout-cart', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'checkout',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/checkout'
    });
        

    isNotRegistered('checkout-delivery-options') && (binding.modules['checkout-delivery-options'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout-delivery-options' */
            'partner/modules/checkout-delivery-options/checkout-delivery-options.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'checkout-delivery-options',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/checkout-delivery-options'
    });
        

    isNotRegistered('checkout-guest-profile') && (binding.modules['checkout-guest-profile'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout-guest-profile' */
            'partner/modules/checkout-guest-profile/checkout-guest-profile.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 1},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'checkout-guest-profile',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/checkout-guest-profile'
    });
        

    isNotRegistered('checkout-payment-instrument') && (binding.modules['checkout-payment-instrument'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout-payment-instrument' */
            'partner/modules/checkout-payment-instrument/checkout-payment-instrument.tsx'),
        $type: 'contentModule',
        da: [{name:'cardPaymentAcceptPoint',  path:'modules/checkout-payment-instrument/actions/get-card-payment-accept-point', runOn: 1},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'checkout-payment-instrument',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/checkout-payment-instrument'
    });
        

    isNotRegistered('checkout-shipping-address') && (binding.modules['checkout-shipping-address'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout-shipping-address' */
            'partner/modules/checkout-shipping-address/checkout-shipping-address.tsx'),
        $type: 'contentModule',
        da: [{name:'address',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0},{name:'addressPurposes',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes', runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'countryRegions',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions', runOn: 0},{name:'countryStates',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'checkout-shipping-address',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/checkout-shipping-address'
    });
        

    isNotRegistered('color-a-rainbow-for-crayon-day') && (binding.modules['color-a-rainbow-for-crayon-day'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-color-a-rainbow-for-crayon-day' */
            'partner/modules/color-a-rainbow-for-crayon-day/color-a-rainbow-for-crayon-day.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'color-a-rainbow-for-crayon-day',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/color-a-rainbow-for-crayon-day'
    });
        

    isNotRegistered('color-a-thank-you-sign') && (binding.modules['color-a-thank-you-sign'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-color-a-thank-you-sign' */
            'partner/modules/color-a-thank-you-sign/color-a-thank-you-sign.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'color-a-thank-you-sign',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/color-a-thank-you-sign'
    });
        

    isNotRegistered('connect-the-dots-for-a-playful-peek') && (binding.modules['connect-the-dots-for-a-playful-peek'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-connect-the-dots-for-a-playful-peek' */
            'partner/modules/connect-the-dots-for-a-playful-peek/connect-the-dots-for-a-playful-peek.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'connect-the-dots-for-a-playful-peek',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/connect-the-dots-for-a-playful-peek'
    });
        

    isNotRegistered('contact-us') && (binding.modules['contact-us'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-contact-us' */
            'partner/modules/contact-us/contact-us.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'contact-us',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/contact-us'
    });
        

    isNotRegistered('crayon-slime') && (binding.modules['crayon-slime'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-crayon-slime' */
            'partner/modules/crayon-slime/crayon-slime.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'crayon-slime',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/crayon-slime'
    });
        

    isNotRegistered('dinosaur-fossils') && (binding.modules['dinosaur-fossils'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-dinosaur-fossils' */
            'partner/modules/dinosaur-fossils/dinosaur-fossils.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'dinosaur-fossils',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/dinosaur-fossils'
    });
        

    isNotRegistered('diy-activities') && (binding.modules['diy-activities'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-diy-activities' */
            'partner/modules/diy-activities/diy-activities.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'diy-activities',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/diy-activities'
    });
        

    isNotRegistered('dream-career-with-barbie') && (binding.modules['dream-career-with-barbie'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-dream-career-with-barbie' */
            'partner/modules/dream-career-with-barbie/dream-career-with-barbie.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'dream-career-with-barbie',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/dream-career-with-barbie'
    });
        

    isNotRegistered('earth-day-unprintable') && (binding.modules['earth-day-unprintable'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-earth-day-unprintable' */
            'partner/modules/earth-day-unprintable/earth-day-unprintable.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'earth-day-unprintable',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/earth-day-unprintable'
    });
        

    isNotRegistered('earth-day-unprintable-2') && (binding.modules['earth-day-unprintable-2'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-earth-day-unprintable-2' */
            'partner/modules/earth-day-unprintable-2/earth-day-unprintable-2.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'earth-day-unprintable-2',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/earth-day-unprintable-2'
    });
        

    isNotRegistered('eid-with-geoffrey') && (binding.modules['eid-with-geoffrey'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-eid-with-geoffrey' */
            'partner/modules/eid-with-geoffrey/eid-with-geoffrey.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'eid-with-geoffrey',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/eid-with-geoffrey'
    });
        

    isNotRegistered('email-sign-up') && (binding.modules['email-sign-up'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-email-sign-up' */
            'partner/modules/email-sign-up/email-sign-up.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'email-sign-up',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/email-sign-up'
    });
        

    isNotRegistered('email-sign-up-ar') && (binding.modules['email-sign-up-ar'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-email-sign-up-ar' */
            'partner/modules/email-sign-up-ar/email-sign-up-ar.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'email-sign-up-ar',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/email-sign-up-ar'
    });
        

    isNotRegistered('feature-product-list') && (binding.modules['feature-product-list'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-feature-product-list' */
            'partner/modules/feature-product-list/feature-product-list.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'feature-product-list',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/feature-product-list'
    });
        

    isNotRegistered('featured-list-four') && (binding.modules['featured-list-four'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-featured-list-four' */
            'partner/modules/featured-list-four/featured-list-four.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'featured-list-four',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/featured-list-four'
    });
        

    isNotRegistered('featured-list-one') && (binding.modules['featured-list-one'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-featured-list-one' */
            'partner/modules/featured-list-one/featured-list-one.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'featured-list-one',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/featured-list-one'
    });
        

    isNotRegistered('featured-list-three') && (binding.modules['featured-list-three'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-featured-list-three' */
            'partner/modules/featured-list-three/featured-list-three.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'featured-list-three',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/featured-list-three'
    });
        

    isNotRegistered('featured-list-two') && (binding.modules['featured-list-two'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-featured-list-two' */
            'partner/modules/featured-list-two/featured-list-two.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'featured-list-two',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/featured-list-two'
    });
        

    isNotRegistered('geoffrey-and-elephants-pool-time-hidden-picture-puzzle') && (binding.modules['geoffrey-and-elephants-pool-time-hidden-picture-puzzle'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-geoffrey-and-elephants-pool-time-hidden-picture-puzzle' */
            'partner/modules/geoffrey-and-elephants-pool-time-hidden-picture-puzzle/geoffrey-and-elephants-pool-time-hidden-picture-puzzle.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'geoffrey-and-elephants-pool-time-hidden-picture-puzzle',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/geoffrey-and-elephants-pool-time-hidden-picture-puzzle'
    });
        

    isNotRegistered('geoffrey-and-rhinos-color-by-numbers-cool-concert') && (binding.modules['geoffrey-and-rhinos-color-by-numbers-cool-concert'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-geoffrey-and-rhinos-color-by-numbers-cool-concert' */
            'partner/modules/geoffrey-and-rhinos-color-by-numbers-cool-concert/geoffrey-and-rhinos-color-by-numbers-cool-concert.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'geoffrey-and-rhinos-color-by-numbers-cool-concert',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/geoffrey-and-rhinos-color-by-numbers-cool-concert'
    });
        

    isNotRegistered('geoffrey-party-room') && (binding.modules['geoffrey-party-room'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-geoffrey-party-room' */
            'partner/modules/geoffrey-party-room/geoffrey-party-room.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'geoffrey-party-room',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/geoffrey-party-room'
    });
        

    isNotRegistered('geoffreys-guitar-solo-color-by-numbers') && (binding.modules['geoffreys-guitar-solo-color-by-numbers'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-geoffreys-guitar-solo-color-by-numbers' */
            'partner/modules/geoffreys-guitar-solo-color-by-numbers/geoffreys-guitar-solo-color-by-numbers.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'geoffreys-guitar-solo-color-by-numbers',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/geoffreys-guitar-solo-color-by-numbers'
    });
        

    isNotRegistered('geoffreys-pizza-party') && (binding.modules['geoffreys-pizza-party'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-geoffreys-pizza-party' */
            'partner/modules/geoffreys-pizza-party/geoffreys-pizza-party.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'geoffreys-pizza-party',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/geoffreys-pizza-party'
    });
        

    isNotRegistered('hot-and-new') && (binding.modules['hot-and-new'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hot-and-new' */
            'partner/modules/hot-and-new/hot-and-new.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hot-and-new',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hot-and-new'
    });
        

    isNotRegistered('jobs') && (binding.modules['jobs'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-jobs' */
            'partner/modules/jobs/jobs.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'jobs',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/jobs'
    });
        

    isNotRegistered('lego-photo-frame') && (binding.modules['lego-photo-frame'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lego-photo-frame' */
            'partner/modules/lego-photo-frame/lego-photo-frame.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'lego-photo-frame',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lego-photo-frame'
    });
        

    isNotRegistered('monster-jam-car-wash') && (binding.modules['monster-jam-car-wash'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-monster-jam-car-wash' */
            'partner/modules/monster-jam-car-wash/monster-jam-car-wash.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'monster-jam-car-wash',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/monster-jam-car-wash'
    });
        

    isNotRegistered('no-sew-doll-carrier') && (binding.modules['no-sew-doll-carrier'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-no-sew-doll-carrier' */
            'partner/modules/no-sew-doll-carrier/no-sew-doll-carrier.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'no-sew-doll-carrier',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/no-sew-doll-carrier'
    });
        

    isNotRegistered('no-sew-superhero-cape') && (binding.modules['no-sew-superhero-cape'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-no-sew-superhero-cape' */
            'partner/modules/no-sew-superhero-cape/no-sew-superhero-cape.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'no-sew-superhero-cape',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/no-sew-superhero-cape'
    });
        

    isNotRegistered('origami-butterfly') && (binding.modules['origami-butterfly'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-origami-butterfly' */
            'partner/modules/origami-butterfly/origami-butterfly.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'origami-butterfly',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/origami-butterfly'
    });
        

    isNotRegistered('our-stores') && (binding.modules['our-stores'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-our-stores' */
            'partner/modules/our-stores/our-stores.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'our-stores',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/our-stores'
    });
        

    isNotRegistered('our-stores-ar') && (binding.modules['our-stores-ar'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-our-stores-ar' */
            'partner/modules/our-stores-ar/our-stores-ar.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'our-stores-ar',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/our-stores-ar'
    });
        

    isNotRegistered('play-at-home') && (binding.modules['play-at-home'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-play-at-home' */
            'partner/modules/play-at-home/play-at-home.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'play-at-home',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/play-at-home'
    });
        

    isNotRegistered('playdoh-how-to-make-a-beach-ball') && (binding.modules['playdoh-how-to-make-a-beach-ball'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-playdoh-how-to-make-a-beach-ball' */
            'partner/modules/playdoh-how-to-make-a-beach-ball/playdoh-how-to-make-a-beach-ball.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'playdoh-how-to-make-a-beach-ball',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/playdoh-how-to-make-a-beach-ball'
    });
        

    isNotRegistered('playdoh-how-to-make-a-bunny') && (binding.modules['playdoh-how-to-make-a-bunny'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-playdoh-how-to-make-a-bunny' */
            'partner/modules/playdoh-how-to-make-a-bunny/playdoh-how-to-make-a-bunny.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'playdoh-how-to-make-a-bunny',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/playdoh-how-to-make-a-bunny'
    });
        

    isNotRegistered('playdoh-how-to-make-a-castle') && (binding.modules['playdoh-how-to-make-a-castle'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-playdoh-how-to-make-a-castle' */
            'partner/modules/playdoh-how-to-make-a-castle/playdoh-how-to-make-a-castle.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'playdoh-how-to-make-a-castle',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/playdoh-how-to-make-a-castle'
    });
        

    isNotRegistered('playdoh-how-to-make-apple') && (binding.modules['playdoh-how-to-make-apple'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-playdoh-how-to-make-apple' */
            'partner/modules/playdoh-how-to-make-apple/playdoh-how-to-make-apple.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'playdoh-how-to-make-apple',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/playdoh-how-to-make-apple'
    });
        

    isNotRegistered('pokemon-activities-roundup') && (binding.modules['pokemon-activities-roundup'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-pokemon-activities-roundup' */
            'partner/modules/pokemon-activities-roundup/pokemon-activities-roundup.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'pokemon-activities-roundup',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/pokemon-activities-roundup'
    });
        

    isNotRegistered('printables') && (binding.modules['printables'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-printables' */
            'partner/modules/printables/printables.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'printables',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/printables'
    });
        

    isNotRegistered('product-container-one') && (binding.modules['product-container-one'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-product-container-one' */
            'partner/modules/product-container-one/product-container-one.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'product-container-one',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/product-container-one'
    });
        

    isNotRegistered('product-container-three') && (binding.modules['product-container-three'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-product-container-three' */
            'partner/modules/product-container-three/product-container-three.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'product-container-three',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/product-container-three'
    });
        

    isNotRegistered('puppy-day-match-em-up') && (binding.modules['puppy-day-match-em-up'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-puppy-day-match-em-up' */
            'partner/modules/puppy-day-match-em-up/puppy-day-match-em-up.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'puppy-day-match-em-up',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/puppy-day-match-em-up'
    });
        

    isNotRegistered('ramadan-with-geoffrey') && (binding.modules['ramadan-with-geoffrey'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-ramadan-with-geoffrey' */
            'partner/modules/ramadan-with-geoffrey/ramadan-with-geoffrey.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'ramadan-with-geoffrey',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/ramadan-with-geoffrey'
    });
        

    isNotRegistered('return-and-exchange') && (binding.modules['return-and-exchange'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-return-and-exchange' */
            'partner/modules/return-and-exchange/return-and-exchange.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'return-and-exchange',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/return-and-exchange'
    });
        

    isNotRegistered('sign-up') && (binding.modules['sign-up'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-sign-up' */
            'partner/modules/sign-up/sign-up.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'sign-up',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/sign-up'
    });
        

    isNotRegistered('small-banner') && (binding.modules['small-banner'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-small-banner' */
            'partner/modules/small-banner/small-banner.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'small-banner',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/small-banner'
    });
        

    isNotRegistered('toy-reviews') && (binding.modules['toy-reviews'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-toy-reviews' */
            'partner/modules/toy-reviews/toy-reviews.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'toy-reviews',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/toy-reviews'
    });
        

    isNotRegistered('toy-shadow-tracing') && (binding.modules['toy-shadow-tracing'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-toy-shadow-tracing' */
            'partner/modules/toy-shadow-tracing/toy-shadow-tracing.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'toy-shadow-tracing',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/toy-shadow-tracing'
    });
        

    isNotRegistered('toy-trends') && (binding.modules['toy-trends'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-toy-trends' */
            'partner/modules/toy-trends/toy-trends.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'toy-trends',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/toy-trends'
    });
        

    isNotRegistered('toysrus') && (binding.modules['toysrus'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-toysrus' */
            'partner/themes/toysrus/toysrus.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['buybox','cart','content-block','header','media-gallery','navigation-menu','product-collection','promo-banner','search-result-container','text-block'],
        iNM: false,
        ns: '__local__',
        n: 'toysrus',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'toysrus.theme.settings.json',
        md: 'src/themes/toysrus'
    });
        

    isNotRegistered('toysrus-banner') && (binding.modules['toysrus-banner'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-toysrus-banner' */
            'partner/modules/toysrus-banner/toysrus-banner.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'toysrus-banner',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/toysrus-banner'
    });
        

    isNotRegistered('toysrus-eidbox-ar') && (binding.modules['toysrus-eidbox-ar'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-toysrus-eidbox-ar' */
            'partner/modules/toysrus-eidbox-ar/toysrus-eidbox-ar.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'toysrus-eidbox-ar',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/toysrus-eidbox-ar'
    });
        

    isNotRegistered('toysrus-eidbox-en') && (binding.modules['toysrus-eidbox-en'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-toysrus-eidbox-en' */
            'partner/modules/toysrus-eidbox-en/toysrus-eidbox-en.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'toysrus-eidbox-en',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/toysrus-eidbox-en'
    });
        

    isNotRegistered('toysrus-faq') && (binding.modules['toysrus-faq'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-toysrus-faq' */
            'partner/modules/toysrus-faq/toysrus-faq.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'toysrus-faq',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/toysrus-faq'
    });
        

    isNotRegistered('toysrus-footer') && (binding.modules['toysrus-footer'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-toysrus-footer' */
            'partner/modules/toysrus-footer/toysrus-footer.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'toysrus-footer',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/toysrus-footer'
    });
        

    isNotRegistered('toysrus-giftfinder') && (binding.modules['toysrus-giftfinder'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-toysrus-giftfinder' */
            'partner/modules/toysrus-giftfinder/toysrus-giftfinder.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'toysrus-giftfinder',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/toysrus-giftfinder'
    });
        

    isNotRegistered('toysrus-giftfinder-ar') && (binding.modules['toysrus-giftfinder-ar'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-toysrus-giftfinder-ar' */
            'partner/modules/toysrus-giftfinder-ar/toysrus-giftfinder-ar.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'toysrus-giftfinder-ar',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/toysrus-giftfinder-ar'
    });
        

    isNotRegistered('toysrus-image') && (binding.modules['toysrus-image'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-toysrus-image' */
            'partner/modules/toysrus-image/toysrus-image.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'toysrus-image',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/toysrus-image'
    });
        

    isNotRegistered('toysrus-language-selector') && (binding.modules['toysrus-language-selector'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-toysrus-language-selector' */
            'partner/modules/toysrus-language-selector/toysrus-language-selector.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'toysrus-language-selector',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/toysrus-language-selector'
    });
        

    isNotRegistered('wwe-coloring-and-activity-sheets') && (binding.modules['wwe-coloring-and-activity-sheets'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-wwe-coloring-and-activity-sheets' */
            'partner/modules/wwe-coloring-and-activity-sheets/wwe-coloring-and-activity-sheets.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'wwe-coloring-and-activity-sheets',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/wwe-coloring-and-activity-sheets'
    });
        

        {   
            const actionPath = 'actions/get-full-available-inventory-nearby-hook.action';
            binding.dataActions[actionPath] = require('partner/actions/get-full-available-inventory-nearby-hook.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-full-products-by-collection.action';
            binding.dataActions[actionPath] = require('partner/actions/get-full-products-by-collection.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-product-availabilities-for-selected-variant.action';
            binding.dataActions[actionPath] = require('partner/actions/get-product-availabilities-for-selected-variant.action');
            registerActionId(actionPath);
        }

        if (isNotRegistered('checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout')){
            const sanitizedActionPath = 'modules/checkout/actions/get-products-in-active-checkout-cart';
            let dataAction = require('partner/modules/checkout/actions/get-products-in-active-checkout-cart');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-delivery-options')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-delivery-options')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-delivery-options')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-delivery-options')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-guest-profile')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-guest-profile')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-payment-instrument')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-payment-instrument')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-payment-instrument')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-payment-instrument')){
            const sanitizedActionPath = 'modules/checkout-payment-instrument/actions/get-card-payment-accept-point';
            let dataAction = require('partner/modules/checkout-payment-instrument/actions/get-card-payment-accept-point');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

    
    } catch (e) {
        handleError('-', e);
    }
    
    return binding;
};